import React, { useState, useEffect, useRef } from "react";
import EditRoomList from "../../../assets/img/dashboard/editRoomList";
import DelRoomList from "../../../assets/img/dashboard/delRoomList";
import Reset from "../../../assets/img/dashboard/reset";

function RoomList({ name, id, editList, delList }) {
  const [roomName, setName] = useState(name);
  const [toggle, setToggle] = useState(false);
  const [del, setDel] = useState(false);
  const searchRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = ({ target }) => {
      if (toggle === true && !searchRef.current.contains(target)) {
        if (name !== roomName) {
          editList(id, roomName);
        }
        setToggle(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [editList, id, name, roomName, toggle]);

  const focusInput = () => {
    searchRef.current.focus();
  };

  const handleKeyPress = (e) => {
    // enter 이벤트로 수정값 적용
    if (e.key === "Enter") {
      if (roomName && roomName.length > 0 && toggle) {
        editList(id, roomName);
        setToggle(!toggle);
      }
    }
  };

  return (
    <>
      <input
        className={toggle && "editForm"}
        ref={searchRef}
        type="text"
        value={roomName}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyPress={(e) => {
          handleKeyPress(e);
        }}
      />
      {!toggle && (
        <>
          <span className={(toggle && "hide") || (del && "del")}>
            {roomName}
          </span>
          <button
            type="button"
            className={del ? "hideEdit" : "editButton"}
            onClick={() => {
              if (!del) {
                focusInput();
                setToggle(!toggle);
              }
            }}
          >
            <EditRoomList />
          </button>
          <button
            type="button"
            onClick={() => {
              delList(id, roomName, del, setDel(!del));
            }}
          >
            {del ? <Reset /> : <DelRoomList />}
          </button>
        </>
      )}
    </>
  );
}

export default RoomList;
